<template>
  <div>
  <mw-dialog  size="large_large" title="恢复作废文件" ref="dialog">
    <div class="mw-toolbar">
      <!--<el-button @click="remove">删除</el-button>-->
      <el-button @click="active">恢复</el-button>
    </div>
    <div class="mw-toolbar__body mw-app__edit" style="">
      <div class="mw-pagination__body">
      <el-table
        stripe
        border
        :data="dataList"
        height="100%"
        class='mw-table'
        style="width: 100%"
        @selection-change = "handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="40"
        />
        <el-table-column prop="businessName" label="标题" width="350"/>
        <el-table-column prop="name" label="当前环节" width="180"/>
        <el-table-column prop="sender" label="发件人" width="80"/>
        <el-table-column prop="suspendTime" label="删除时间" width="160"/>
      </el-table>
      </div>
      <div class="mw-pagination">
        <simple-pagination v-model="pagination" @input="updateTable"/>
      </div>
    </div>
  </mw-dialog>
  </div>
</template>

<script>
  import api from "@/common/api/maintain";
  import SimplePagination from "../common/simplePagination";
  export default {
    data() {
      return {
        selection: [],
        dataList: [],
        pagination: {
          limit: 100,
          start: 0,
          total: 0
        }
      };
    },

    methods: {
      handleSelectionChange(selection) {
        this.selection = selection;
      },
      async remove(){
        if ((await this.mwConfirm('确定删除'))) {
          const {success} = await api.deleteDocument(this.selection.map(x => x.draftsDocId),{});
          if (success) {
            this.mwMsg('删除成功');
            this.updateTable();
            this.$emit("updateTable");
          }
        }
      },
      async active(){
        if (this.selection.length < 1) {
          this.mwMsg("warning", "请至少选择一条记录。");
          return;
        }
        const {success} = await api.activeDocument(this.selection.map(x => x.batchId), {});
        if (success) {
          this.mwMsg('恢复成功');
          this.updateTable();
          this.$emit("updateTable");
        }
      },
      async action() {
        this.mwRef("dialog").show();
        this.getListFlowSuspend();
      },
      async getListFlowSuspend() {
        const { result } =await api.listFlowSuspend({start:0,limit:10});
        this.dataList =result;
      },
      async updateTable() {
        const { result, success, totalCount } = await api.listFlowSuspend(
          {
            start: this.pagination.start,
            limit: this.pagination.limit
          }
        );

        this.dataList = result;
        this.pagination = { ...this.pagination, total: parseInt(totalCount, 10) };
      },
    },
    components: {
      SimplePagination
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/recycle.vue